export default "__VITE_ASSET__DzpWl7Fd__"